<template>
  <div class="show-ticket">
    <p>
      <router-link class="back" to="/historique">
        <i class="fa fa-arrow-left"></i> retour
      </router-link>
    </p>
    <div class="ticket printable">
      <h3>Ticket: {{ $route.params.id }}</h3>
      <p>{{ toSimple(commande.date) }}</p>
      <QRCode :data="vcf" :alt="getAlt"></QRCode>
      <TicketClient :client="cli"></TicketClient>
      <TicketMenu
        v-for="m in commande.menus"
        :menu="m"
        :key="m.uid"
      ></TicketMenu>
      <hr />
      <table class="summary price">
        <tr>
          <td>total</td>
          <td>{{ toFixed(p["total"]) }}</td>
        </tr>
        <tr>
          <td>rabais</td>
          <td>-{{ toFixed(commande.rabais) }}</td>
        </tr>
        <tr>
          <td>payee</td>
          <td>{{ toFixed(p["apayer"]) }}</td>
        </tr>
      </table>

      <hr />
    </div>
  </div>
</template>
<script>

import { toFixed } from '@/lib/codecimal.js';
import { toSimple } from '@/lib/timedate.js';
import vcard from "@/models/vcard.js";
import { empty, price } from "@/models/commande.js";

import QRCode from "@/components/base/QRCode.vue";
import TicketMenu from "@/components/ticket/TicketMenu.vue";
import TicketClient from "@/components/ticket/TicketClient.vue";

export default {
  name: "ShowTicket",
  components: { QRCode, TicketMenu, TicketClient },
  mounted() {
    let id = this.$route.params.id;
      this.$db.commandes.get(id)
        .then(d => (this.commande = d.commande))
        .catch(console.log);
  },
  data() {
    return {
      commande: empty()
    };
  },
  methods: { toFixed(s) { return toFixed(s); }, toSimple(d) { return toSimple(new Date(d)); } },
  computed: {
    p() {
      return price(this.commande);
    },
    getAlt() {
      return `qr-code for commande ${this.$route.params.id}`;
    },
    cli() {
      return this.commande.client;
    },
    vcf() {
      return vcard(this.commande.client);
    },
    showClient() {
      let c = this.commande.client;
      return c.nom + " tel:(" + c.numero + "), " + c.rue + " " + c.ville;
    }
  }
};
</script>

<style>
  .show-ticket {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ticket {
padding: 1em;
width: 40%;
min-width: 25em;
//background-color: #d2ffca;
  display: block;
}

.ticket h3 { text-align: center; }
.ticket p { text-align: center; }

// tr:nth-child(even) { background-color: rgb(190, 253, 190); /* #fafafa; */}
tr:nth-child(even) { background-color: #fafafa; }

.ticket table {
width: 100%;
}

.ticket table td:last-child {
width: 15%;
text-align: right;
}

.summary { font-weight: bold; }
</style>
